import type { Filter } from "../../../../components/FilterChips/FilterChips";

import type { SearchServiceSort } from "../../../../api/hooks";

import type { ListRolesParams, RoleSortBy } from "../../../../api/services/defs/roles";

import { DEFAULT_FILTERS, type RolesFilters, STATUS_LABELS } from "./schema";

type FiltersInput = Partial<RolesFilters>;

const resolveStatus = (filters: FiltersInput): RolesFilters["status"] => filters.status ?? DEFAULT_FILTERS.status;

export const convertFiltersToFilterChips = (filters: FiltersInput): Filter[] => [
	{ id: "status", type: "string", label: "Status", value: STATUS_LABELS[resolveStatus(filters)] },
];

export const getNonDismissibleChipIds = (filters: FiltersInput): string[] =>
	resolveStatus(filters) === DEFAULT_FILTERS.status ? ["status"] : [];

type RolesRequestParams = Pick<ListRolesParams, "name" | "status" | "sortBy" | "sortOrder">;

export const colIdToSortBy = (colId: string | undefined): RoleSortBy | null => {
	if (colId === "name" || colId === "description" || colId === "status") return colId;
	if (colId === "employees") return "employees_count";
	if (colId === "competencies") return "competencies_count";
	return null;
};

export const getRolesListParams = (
	filters: FiltersInput,
	searchValue: string,
	sort?: SearchServiceSort
): RolesRequestParams => {
	const params: RolesRequestParams = { status: resolveStatus(filters) };

	const trimmedSearch = searchValue.trim();
	if (trimmedSearch) {
		params.name = trimmedSearch;
	}

	if (sort?.name) {
		const mapped = colIdToSortBy(sort.name);
		if (mapped) {
			params.sortBy = mapped;
			params.sortOrder = sort.direction === "desc" ? "desc" : "asc";
		}
	}

	return params;
};
